import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Homepage";
import ThankYou from "./Thankyou";
import DSH from "./Dsh";
import EbookForm from "./EbookForm";
import Newsletter from "./newsletter";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dsh" element={<DSH />} />
        <Route path="/ns" element={<Newsletter />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/Idea-to-funding-Ebook" element={<EbookForm />} />
      </Routes>
    </Router>
  );
}

export default App;
